import { render, staticRenderFns } from "./Responder.vue?vue&type=template&id=6053e5bd&scoped=true"
import script from "./Responder.vue?vue&type=script&lang=js"
export * from "./Responder.vue?vue&type=script&lang=js"
import style0 from "./Responder.vue?vue&type=style&index=0&id=6053e5bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6053e5bd",
  null
  
)

export default component.exports